"use client";
import Button from "@/app/pwa/components/Button";
import NoContent from "@/app/pwa/components/NoContent";
import { Match as IMatch } from "@/sources/kicker-amateur/types";
import React, { useEffect, useState } from "react";
import { ClubTeamScheduleMatch } from "./ClubTeamScheduleMatch";

interface ClubTeamScheduleProps {
  schedule: IMatch[];
  teamId: number;
}

export function ClubTeamSchedule({ schedule, teamId }: ClubTeamScheduleProps) {
  const [scrolling, setScrolling] = useState(true);
  const now = Date.now();
  useEffect(() => {
    const nearestMatches = schedule.filter(
      (m) => m.Kickoff && new Date(m.Kickoff).getTime() < now
    );
    const nearestMatch = nearestMatches.slice(-2)[0];

    if (nearestMatch) {
      const element = document.getElementById(nearestMatch.Id!.toString());
      const container = document.getElementById("container");
      const tabnav = document.getElementById("tab-nav");
      if (container && element && tabnav) {
        container.scrollTop =
          element.offsetTop -
          container.offsetTop -
          tabnav.clientHeight +
          element.clientHeight;
      }
    }
    setScrolling(false);
  },[setScrolling, now, schedule]);
  return (
    <div className={scrolling ? "opacity-0" : "opacity-100"}>
      {schedule && schedule.length > 0 ? (
        schedule.map((match) => (
          <ClubTeamScheduleMatch
            key={`ClubTeamSchedule-${teamId}-${match?.Id}`}
            match={match}
            teamId={teamId}
          />
        ))
      ) : (
        <NoContent>Keine Spiele</NoContent>
      )}
    </div>
  );
}
